import cssModule from "./index.module.css"

/**
 * Страница 404
 * @component
 * @category Component
 */
export function Page404() {
	return (
		<div className={cssModule.root}>
			<h1>404</h1>
			<h1>Страница не найдена!</h1>
		</div>
	)
}
